const domain = {
  prod: "https://api.mzplus.com",
  uat: "http://localhost:8082",
};

const bookDomain = {
  prod: "https://bookuhk.magv.com/",
  uat: "http://localhost:5002",
};

const lcids = [
  { title: "台灣", key: "1028" },
  { title: "香港", key: "3076" },
  { title: "中國", key: "2052" },
  { title: "日本", key: "1041" },
];

const API = {
  version: "v2",
  magz: {
    brand: {
      page: "/api/v2/magz/brand",
      oldmags: (brandcode) => `/api/v2/magz/brands/${brandcode}`,
      issue: (issueId) => `/api/v2/magz/issue/${issueId}`,
      chapter: (nmid) => `/api/v2/magz/chapter/${nmid}`,
    },
    search: "/api/v2/express/search",
  },
  Code: {
    ok: "OK",
  },
};

const bookAPI = {
  version: "v1",
  book: {
    books: "/api/v1/Book/books",
    info: (isbn) => `/api/v1/Book/${isbn}`,
    page: (isbn, pageno) => `/api/v1/Book/${isbn}/${pageno}`,
  },
  magz: {
    log: (brandcode, title, no, issuseId, chapterno) =>
      `/api/v1/Mag/log/${brandcode}/${title}/${no}/${issuseId}/${chapterno}`,
  },
};

export { domain, API, lcids, bookAPI, bookDomain };
